/*@ngInject*/
const SystemPreferenceController = function ($element, $scope, $rootScope, $stateParams, authorizationConstants, configurationConstant, coreConstant, coreMediator, currentUserModel, dataSetUtil, defaultPreferencesDataType, localization, systemPreferencesManagerModel) {
    $element.addClass('systemPreference');

    this.controlsVisible = false;
    this.controlsFrozen = false;
    this.valid = true;
    this.defaultPreferencesDataType = defaultPreferencesDataType;
    this.tooltip = null;
    this.errorTooltip = {};
    this.showDescription = false;
    this.isCheckbox = false;
    this.isString = false;
    this.isNumeric = false;
    this.isSingleSelect = false;
    this.isMultiSelect = false;
    this.checkboxModel = false;
    this.numericModel;
    this.hasManagePermission = false;

    this.$onInit = function () {
        this.isCheckbox = this.systemPreference.dataType === defaultPreferencesDataType.BOOLEAN;
        this.isSingleSelect = this.systemPreference.dataType === defaultPreferencesDataType.ENUM_SINGLE_SELECT;
        this.isMultiSelect = this.systemPreference.dataType === defaultPreferencesDataType.ENUM_MULTI_SELECT;
        this.isNumeric = this.systemPreference.dataType === defaultPreferencesDataType.NUMERIC;
        this.isString = this.systemPreference.dataType === defaultPreferencesDataType.STRING || _.isNil(this.systemPreference.dataType);
        this.hasManagePermission = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_BA_STUDIO_PREFERENCES);

        if (this.isCheckbox) {
            this.checkboxModel = this.systemPreference.value === 'true';
        } else if (this.isNumeric) {
            this.numericModel = parseFloat(this.systemPreference.value);
        } else if (this.isSingleSelect || this.isMultiSelect) {
            if (!_.isNil(this.systemPreference.dataSetName) && !_.isEmpty(this.systemPreference.dataSetName)) {
                dataSetUtil.getDataSet({name: this.systemPreference.dataSetName}).then((dataSet) => {
                    this.preferenceOptions = dataSet.items;
                });
            }
        }


    };

    localization.getTranslationByKey('systemPreference').then(function (translations) {
        this.errorTooltip = {
            message: _.get(translations, 'numericValidationError'),
            type: 'errorPopover',
            delay: 500
        }

        this.getTooltip = function () {
            let message = _.get(translations, 'infoTooltipMessage');

            message = _.replace(_.replace(message, '{completeDescription}', this.systemPreference.completeDescription), '{name}', this.systemPreference.name);

            return message;
        };
    }.bind(this));

    this.getTooltip = function () {
        let message = '';
        if (!_.isNil(this.systemPreference.completeDescription) && this.systemPreference.completeDescription !== "") {
            message += this.systemPreference.completeDescription + '\n\n';
        }

        message += 'Name: ' + this.systemPreference.name;

        return message;
    };

    this.getShortDescription = function () {
        if (_.isNil(this.systemPreference.shortDescription) || this.systemPreference.shortDescription === "") {
            return this.systemPreference.name;
        }

        return this.systemPreference.shortDescription;
    };

    this.getSystemPreferenceUniqueClass = function () {
        let preferenceName = _.replace(this.systemPreference.name, /\./g, '-');
        return preferenceName;
    };

    this.handleToggleButtonClick = function (value) {
        this.checkboxModel = value;
        this.handleChange();
    };

    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, (event, itemName) => {
        if (itemName === this.getSystemPreferenceUniqueClass()) {
            let selectedOptions = [];
            _.each(this.preferenceOptions, function (preferenceOption) {
                if (preferenceOption.selected) {
                    selectedOptions.push(preferenceOption.value);
                }
            });

            let selectedValue = _.join(selectedOptions, ',');
            this.systemPreference.value = selectedValue;
            this.handleChange();
        }
    });

    $scope.$on(coreConstant.event.MULTI_SELECT_CLOSED, (event, itemName) => {
        if (itemName === this.getSystemPreferenceUniqueClass()) {
            this.unfreezeControls();
        }
    });

    this.handleSelect = function (selectedOption) {
        this.systemPreference.value = selectedOption.value;
        this.unfreezeControls();
        this.handleChange();
    };

    this.handleDropdownClose = function () {
        this.unfreezeControls();
    };

    this.handleChange = function () {
        if (this.isCheckbox) {
            this.systemPreference.value = this.checkboxModel.toString();
        } else if (this.isNumeric) {
            this.systemPreference.value = this.numericModel.toString();
        }
        systemPreferencesManagerModel.setSystemPreferenceValueByName(this.systemPreference.name, this.systemPreference.value);
        $rootScope.$broadcast(configurationConstant.event.SYSTEM_PREFERENCES_MANAGER_MODEL_UPDATED);
    };

    this.handleTextInputChange = function () {
        this.unfreezeControls();
        this.handleChange();
    };

    this.freezeControls = function () {
        this.controlsFrozen = true;
    };

    this.unfreezeControls = function () {
        this.controlsFrozen = false;
        this.hideControls();
    };

    this.showControls = function () {
        if(this.hasManagePermission) {
            this.controlsVisible = true;
        }
        this.showDescription = true;
    };

    this.hideControls = function () {
        if (!this.controlsFrozen) {
            this.controlsVisible = false;
        }
        this.showDescription = false;
    };
};

angular.module('ums.configuration')
    .controller('systemPreferenceController', SystemPreferenceController);
